'use client';

import { useEffect } from 'react';
import { errorLogger } from '@/lib/errorLogger';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    errorLogger.captureError(error, {
      source: 'global-error-boundary',
      digest: error.digest,
    });
  }, [error]);

  return (
    <html lang="en">
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#0a0a0a', color: '#f5f5f5' }}>
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div style={{ maxWidth: 420, width: '100%', border: '1px solid rgba(239, 68, 68, 0.4)', background: 'rgba(127, 29, 29, 0.3)', borderRadius: 8, padding: 24 }}>
            <p style={{ fontSize: 12, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(252, 165, 165, 0.8)', margin: 0, marginBottom: 8 }}>
              Critical Fault
            </p>
            <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0, marginBottom: 12 }}>
              OPMODE failed to load
            </h2>
            <p style={{ fontSize: 14, color: 'rgba(254, 226, 226, 0.8)', margin: 0, marginBottom: 20, lineHeight: 1.5 }}>
              The app hit an unrecoverable error. Details have been logged. Try reloading — if this keeps happening, report it from the bug button.
            </p>
            {error.digest && (
              <p style={{ fontSize: 11, fontFamily: 'monospace', color: 'rgba(252, 165, 165, 0.6)', marginBottom: 16 }}>
                Ref: {error.digest}
              </p>
            )}
            <button
              onClick={reset}
              style={{ width: '100%', background: '#ef4444', color: '#450a0a', fontWeight: 700, padding: '10px 16px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 14 }}
            >
              Reload
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
